/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClientCredentials,
  CreateLiveClientRequestBody,
  CreateTestClientRequestBody,
  LiveClient,
  SandboxClient,
} from '../models/index';
import {
    ClientCredentialsFromJSON,
    ClientCredentialsToJSON,
    CreateLiveClientRequestBodyFromJSON,
    CreateLiveClientRequestBodyToJSON,
    CreateTestClientRequestBodyFromJSON,
    CreateTestClientRequestBodyToJSON,
    LiveClientFromJSON,
    LiveClientToJSON,
    SandboxClientFromJSON,
    SandboxClientToJSON,
} from '../models/index';

export interface CreateLiveClientRequest {
    createLiveClientRequestBody: CreateLiveClientRequestBody;
}

export interface CreateTestClientRequest {
    createTestClientRequestBody: CreateTestClientRequestBody;
}

export interface DeleteLiveClientRequest {
    clientId: string;
}

export interface DeleteTestClientRequest {
    clientId: string;
}

export interface RecreateLiveClientSecretRequest {
    clientId: string;
}

export interface RecreateTestClientSecretRequest {
    clientId: string;
}

/**
 * 
 */
export class ClientResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for createLiveClient without sending the request
     */
    async createLiveClientRequestOpts(requestParameters: CreateLiveClientRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createLiveClientRequestBody'] == null) {
            throw new runtime.RequiredError(
                'createLiveClientRequestBody',
                'Required parameter "createLiveClientRequestBody" was null or undefined when calling createLiveClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/retailerapi/client/live`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLiveClientRequestBodyToJSON(requestParameters['createLiveClientRequestBody']),
        };
    }

    /**
     */
    async createLiveClientRaw(requestParameters: CreateLiveClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LiveClient>> {
        const requestOptions = await this.createLiveClientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LiveClientFromJSON(jsonValue));
    }

    /**
     */
    async createLiveClient(requestParameters: CreateLiveClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LiveClient> {
        const response = await this.createLiveClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createTestClient without sending the request
     */
    async createTestClientRequestOpts(requestParameters: CreateTestClientRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createTestClientRequestBody'] == null) {
            throw new runtime.RequiredError(
                'createTestClientRequestBody',
                'Required parameter "createTestClientRequestBody" was null or undefined when calling createTestClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/retailerapi/client/test`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTestClientRequestBodyToJSON(requestParameters['createTestClientRequestBody']),
        };
    }

    /**
     */
    async createTestClientRaw(requestParameters: CreateTestClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SandboxClient>> {
        const requestOptions = await this.createTestClientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SandboxClientFromJSON(jsonValue));
    }

    /**
     */
    async createTestClient(requestParameters: CreateTestClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SandboxClient> {
        const response = await this.createTestClientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteLiveClient without sending the request
     */
    async deleteLiveClientRequestOpts(requestParameters: DeleteLiveClientRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deleteLiveClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailerapi/client/live/{clientId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteLiveClientRaw(requestParameters: DeleteLiveClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteLiveClientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteLiveClient(requestParameters: DeleteLiveClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLiveClientRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteTestClient without sending the request
     */
    async deleteTestClientRequestOpts(requestParameters: DeleteTestClientRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deleteTestClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailerapi/client/test/{clientId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteTestClientRaw(requestParameters: DeleteTestClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteTestClientRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTestClient(requestParameters: DeleteTestClientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTestClientRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getLiveClient without sending the request
     */
    async getLiveClientRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailerapi/client/live`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getLiveClientRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LiveClient>> {
        const requestOptions = await this.getLiveClientRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LiveClientFromJSON(jsonValue));
    }

    /**
     */
    async getLiveClient(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LiveClient> {
        const response = await this.getLiveClientRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTestClients without sending the request
     */
    async getTestClientsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailerapi/client/test`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getTestClientsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SandboxClient>>> {
        const requestOptions = await this.getTestClientsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SandboxClientFromJSON));
    }

    /**
     */
    async getTestClients(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SandboxClient>> {
        const response = await this.getTestClientsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for recreateLiveClientSecret without sending the request
     */
    async recreateLiveClientSecretRequestOpts(requestParameters: RecreateLiveClientSecretRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling recreateLiveClientSecret().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailerapi/client/live/{clientId}/recreate-secret`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async recreateLiveClientSecretRaw(requestParameters: RecreateLiveClientSecretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientCredentials>> {
        const requestOptions = await this.recreateLiveClientSecretRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientCredentialsFromJSON(jsonValue));
    }

    /**
     */
    async recreateLiveClientSecret(requestParameters: RecreateLiveClientSecretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientCredentials> {
        const response = await this.recreateLiveClientSecretRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for recreateTestClientSecret without sending the request
     */
    async recreateTestClientSecretRequestOpts(requestParameters: RecreateTestClientSecretRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling recreateTestClientSecret().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailerapi/client/test/{clientId}/recreate-secret`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async recreateTestClientSecretRaw(requestParameters: RecreateTestClientSecretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClientCredentials>> {
        const requestOptions = await this.recreateTestClientSecretRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClientCredentialsFromJSON(jsonValue));
    }

    /**
     */
    async recreateTestClientSecret(requestParameters: RecreateTestClientSecretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClientCredentials> {
        const response = await this.recreateTestClientSecretRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
